export const EDIT_MEDIA_SCREEN_NAMESPACE = "EDIT_MEDIA_SCREEN";
